<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Bildirimler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader, 
  },
  data() {
    return {
      title: "Bildirimler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Sistem Yönetimi",
          href: "/",
        },
        {
          text: "Bildirimler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
    };
  },

  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "tlptalepbildirim",
        FullData: true,
        Filter: "&Desc=Created&Tip=1&Personelid=" + this.TokenPersonelId,
      }).then((res) => { 
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    goToDetailPage(Id) {
      this.$router.push({ name: 'talepdetail', params: { Talepid: Id } });
    },
    BildirimOkundu(Data){
        Data.Okundu = true
        this.Update("tlptalepbildirim", Data, "Mesaj Okundu")
    },

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"> 
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>İşlem Tarihi</th>
                      <th>Mesaj</th> 
                      <th>Okundu</th> 
                      <th    class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          " >İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ formatDateTableTime(Data.Created) }}</th>
                      <td>{{ Data.Mesaj }}</td> 
                      <td>{{ Data.Okundu == true ? 'Okundu' : 'Okunmadı' }}</td> 
                      <td>
                        <div
                          class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <b-button-group>
                            <b-button v-if="!Data.Okundu"
                              v-b-tooltip.hover
                              title="Okundu"
                              variant="success" 
                              @click="BildirimOkundu(Data)"
                              ><i class="bx bx-check-double"></i
                            ></b-button>
                            <b-button  v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Talepid)"><i
                                class="far fa-eye"></i></b-button>
                          </b-button-group>  
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
